import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import {
  createPaymentBalance,
  customerCategoryDropdown,
  deliveryToPaymentQuery,
  getCustomerCodeDropdown,
  getPaymentBalanceById,
  UpdatePaymentBalance,
} from "./PaymentBalanceData";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import {
  paymentBalanceState,
  PaymentBalanceStateMange,
} from "./PaymentBalanceStateMange";
import { useLoading } from "../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";
import OptionConvert from "../../components/OptionConvert";
import { allRoles, allUsers } from "./PaymentBalanceData";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";

const PaymentBalanceForm = () => {
  const [paymentBalanceData, dispatch] = useReducer(
    PaymentBalanceStateMange,
    paymentBalanceState
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  const rowId = location?.state?.rowId;
  const payment = location?.state?.type;
  const deliveryId = location?.state?.deliveryId;

  const [roleData, setRoleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [repNameData, setRepName] = useState([]);
  const [repCodeData, setRepCode] = useState([]);
  const [inputDisble, setInputDisble] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [employeeCodeOptions, setEmployeeCodeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerRawList, setCustomerRawList] = useState([]);
  const [customerOptionLoading, setCustomerOptionLoading] = useState(false);
  const { userId } = useAuthData();

  useEffect(() => {
    fetchRoledata();
    fetchUserdata();
    fetchEmployeedata();
  }, []);

  useEffect(() => {
    if (paymentBalanceData?.role !== undefined) {
      const role = paymentBalanceData?.role.label;
      const filterUser = userData.filter(
        (user) => user.role && user.role.role === role
      );
      const userOption = OptionConvert(
        filterUser,
        "employeeName",
        "employeeCode"
      );
      setRepName(userOption);
    }
  }, [paymentBalanceData?.role]);

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.customerCode,
        name: "customerCode",
      });
      dispatch({
        value: formValue?.customerName,
        name: "customerName",
      });
      dispatch({
        value: formValue?.invoiceNumber,
        name: "invoiceNumber",
      });
      dispatch({
        value: formValue?.balance,
        name: "balance",
      });
      dispatch({
        value: { value: formValue?.role?.id, label: formValue?.role?.role },
        name: "role",
      });
      dispatch({
        value: { value: formValue?.repName, label: formValue?.repName },
        name: "repName",
      });
      dispatch({
        value: formValue?.repCode,
        name: "repCode",
      });
      if (formValue?.creditLimit !== undefined) {
        dispatch({
          value: String(formValue.creditLimit),
          name: "creditLimit",
        });
      }
      if (formValue?.category) {
        dispatch({
          value: { label: formValue.category, value: formValue.category },
          name: "category",
        });
      }
      if (formValue?.soDate) {
        dispatch({
          value: formValue.soDate,
          name: "soDate",
        });
      }
      if (formValue?.ageOfInvoice !== undefined) {
        dispatch({
          value: String(formValue.ageOfInvoice),
          name: "ageOfInvoice",
        });
      }
      if (formValue?.ndays !== undefined) {
        dispatch({
          value: String(formValue.ndays),
          name: "ndays",
        });
      }
      setRepCode(formValue?.repCode);
    }
  }, [formValue]);

  useEffect(() => {

    if (formType === "view") return;

    const fetchCustomerCodeDropdown = async () => {
      setCustomerOptionLoading(true);
      try {
        const response = await request(BASEURL, getCustomerCodeDropdown);

        const responseData = response?.getMergedCustomerDropdown?.data;
        if (response?.getMergedCustomerDropdown?.success) {
          setCustomerRawList(responseData || []);
          const optionValues = responseData?.map((item) => ({
            label: item?.customerName
              ? `${item?.customerName} (${item?.customerCode})`
              : item?.customerCode,
            value: item?.customerCode,
            customerData: item,
          }));
          setCustomerOptions(optionValues || []);
        }
        else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: response?.getMergedCustomerDropdown?.message,
            showConfirmButton: true,
          })
        }
      } catch (error) {
        console.error("Error Fetching Customer Code Dropdown", error);
        Swal.fire({
          position: "top",
          icon: "error",
          title: error?.response?.errors?.[0]?.message,
          showConfirmButton: true,
        })
      } finally {
        setCustomerOptionLoading(false);
      }
    };

    const fetchCustomerCategoryDropdown = async () => {
      try {
        const response = await request(BASEURL, customerCategoryDropdown);

        const responseData = response?.customerCategoryDropdown?.data;
        if (response?.customerCategoryDropdown?.success) {
          const optionValues = responseData?.map((item) => ({
            label: item?.customerCategory,
            value: item?.id,
          }));
          setCategoryOptions(optionValues);
        }
        else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: response?.customerCategoryDropdown?.message,
            showConfirmButton: true,
          })
        }
      } catch (error) {
        console.error("Error Fetching Customer Category Dropdown", error);
        Swal.fire({
          position: "top",
          icon: "error",
          title: error?.response?.errors?.[0]?.message,
          showConfirmButton: true,
        })
      }
    };

    fetchCustomerCodeDropdown();
    fetchCustomerCategoryDropdown();
  }, [formType]);

  useEffect(() => {
    if (rowId) {
      fetchById();
    }
  }, [rowId]);

  const fetchById = async () => {
    try {
      const response = await request(BASEURL, getPaymentBalanceById, {
        id: rowId,
      });

      const success = response?.getPaymentBalance?.success;
      const data = response?.getPaymentBalance?.data[0];
      if (success) {
        dispatch({
          value: data?.customerCode,
          name: "customerCode",
        });
        dispatch({
          value: data?.customerName,
          name: "customerName",
        });
        dispatch({
          value: data?.invoiceNumber,
          name: "invoiceNumber",
        });
        dispatch({
          value: data?.balance,
          name: "balance",
        });
        dispatch({
          value: { value: data?.role?.id, label: data?.role?.role },
          name: "role",
        });
        dispatch({
          value: { value: data?.repName, label: data?.repName },
          name: "repName",
        });
        dispatch({
          value: data?.repCode,
          name: "repCode",
        });
        if (data?.creditLimit !== undefined) {
          dispatch({
            value: String(data.creditLimit),
            name: "creditLimit",
          });
        }
        if (data?.category) {
          dispatch({
            value: { label: data.category, value: data.category },
            name: "category",
          });
        }
        if (data?.ageOfInvoice !== undefined) {
          dispatch({
            value: String(data.ageOfInvoice),
            name: "ageOfInvoice",
          });
        }
        if (data?.ndays !== undefined) {
          dispatch({
            value: String(data.ndays),
            name: "ndays",
          });
        }
        if (data?.invoices?.[0]?.soDate) {
          dispatch({
            value: data.invoices[0].soDate,
            name: "soDate",
          });
        }
        setRepCode(data?.repCode);
      } else {
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  //Delivery to Payment screen Data fetching
  useEffect(() => {
    if (!deliveryId) return;
    const deliveryToPayment = async () => {
      try {
        const response = await request(BASEURL, deliveryToPaymentQuery, {
          id: deliveryId,
        });

        const responseData = response.getDeliveryById?.data[0];
        if (payment === "payment") {
          dispatch({
            value: responseData?.customerName,
            name: "customerName",
          });
          dispatch({
            value: {
              value: responseData?.repCode,
              label: responseData?.repCode,
            },
            name: "repCode",
          });
          dispatch({
            value: responseData.repName,
            name: "repName",
          });
        }
      } catch (error) {
        console.error("Error Fetching Data:", error);
      }
    };
    deliveryToPayment();
  }, [deliveryId]);

  //get role data api for select option
  const fetchRoledata = () => {
    setIsLoading(true);
    request(BASEURL, allRoles)
      .then((res) => {
        const roleOption = OptionConvert(res?.allRoles[0]?.data, "role", "id");
        setRoleData(roleOption);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //get user data api for select option
  const fetchUserdata = () => {
    setIsLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        const newdata = res?.allUsers;
        setUserData(newdata);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //submit form
  const handleAddPaymentBalance = async () => {
    const data = {
      repName: paymentBalanceData?.repName,
      repCode:
        paymentBalanceData?.repCode?.code ||
        paymentBalanceData?.repCode?.value ||
        paymentBalanceData?.repCode?.label ||
        paymentBalanceData?.repCode,
      customerName: paymentBalanceData?.customerName,
      customerCode:
        typeof paymentBalanceData?.customerCode === "object"
          ? paymentBalanceData?.customerCode?.value
          : paymentBalanceData?.customerCode,
      invoiceNumber: paymentBalanceData?.invoiceNumber,
      soDate: paymentBalanceData?.soDate,
      balance: paymentBalanceData?.balance,
      ndays: paymentBalanceData?.ndays,
      ageOfInvoice: paymentBalanceData?.ageOfInvoice,
      creditLimit: String(paymentBalanceData?.creditLimit ?? ""),
      category:
        paymentBalanceData?.category?.label ||
        (typeof paymentBalanceData?.category === "string"
          ? paymentBalanceData?.category
          : "") ||
        "",
      partialPaidAmount: "0",
      remainingAmount: "0",
      remarks: "",
    };
    setCirleLoading(true);
    if (formType === "edit") {
      data.id = formValue?.id;
      try {
        const res = await request(BASEURL, UpdatePaymentBalance, {
          input: data,
        });
        const success = res?.updatePaymentBalance?.success;
        const message = res?.updatePaymentBalance?.message;

        if (success) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Successfully Created",
            showConfirmButton: true,
          }).then(() => {
            navigate("/paymentBalance");
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
        }
      } catch (err) {
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Network",
          showConfirmButton: true,
        });
      } finally {
        setCirleLoading(false);
      }
    } else {
      try {
        const res = await request(BASEURL, createPaymentBalance, {
          input: {
            ...data,
            user: userId,
          },
        });

        const success = res?.createPaymentBalance?.success;
        const message = res?.createPaymentBalance?.message;

        if (success) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: message,
            showConfirmButton: true,
          }).then(() => {
            navigate("/paymentBalance");
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
        }
      } catch (err) {
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Network",
          showConfirmButton: true,
        });
      } finally {
        setCirleLoading(false);
      }
    }
  };

  //clear select fields
  const handleRoleChange = (e, s) => {
    dispatch({
      value: "",
      name: "repName",
    });
    setRepCode("");
    dispatch({
      value: e,
      name: s?.name,
    });
  };

  const handleRepNameChange = (e, s) => {
    dispatch({
      value: e,
      name: s?.name,
    });
    if (e !== null) {
      setRepCode(e?.value);
      dispatch({ value: e?.value, name: "repCode" });
    } else {
      setRepCode("");
    }
  };

  //validation for button disable
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      paymentBalanceData.customerCodeStatus === "success" &&
      paymentBalanceData.customerNameStatus === "success" &&
      paymentBalanceData.invoiceNumberStatus === "success" &&
      paymentBalanceData.balanceStatus === "success" &&
      paymentBalanceData.roleStatus === "success" &&
      paymentBalanceData.repNameStatus === "success" &&
      paymentBalanceData.repCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const fetchEmployeedata = async () => {
    setEmployeeLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        setEmployeeCodeOptions(res?.allUsers);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
      })
      .finally(() => {
        setEmployeeLoading(false);
      });
  };
  const handleRepCodeChange = (e, s) => {
    if (e) {
      dispatch({ value: e?.repName || e?.employeeName || "", name: "repName" });
      dispatch({ value: e, name: s?.name || "repCode" });
    } else {
      dispatch({ value: "", name: "repName" });
      dispatch({ value: null, name: s?.name || "repCode" });
    }
  };

  const handleCustomerChange = (e) => {
    if (e) {
      const selected =
        customerRawList.find((item) => item.customerCode === e.value) ||
        e.customerData;

      dispatch({
        value: selected?.customerCode || e.value,
        name: "customerCode",
      });
      dispatch({
        value: selected?.customerName || "",
        name: "customerName",
      });
      dispatch({
        value:
          selected?.creditLimit !== undefined && selected?.creditLimit !== null
            ? String(selected.creditLimit)
            : "0",
        name: "creditLimit",
      });

      const matchedCategory = selected?.customerCategory
        ? categoryOptions.find(
          (cat) =>
            cat.label?.trim()?.toLowerCase() ===
            selected.customerCategory?.trim()?.toLowerCase()
        ) || {
          label: selected.customerCategory,
          value: selected.customerCategory,
        }
        : null;

      dispatch({
        value: matchedCategory,
        name: "category",
      });
    } else {
      dispatch({ value: "", name: "customerCode" });
      dispatch({ value: "", name: "customerName" });
      dispatch({ value: "", name: "creditLimit" });
      dispatch({ value: null, name: "category" });
    }
  };

  const selectedCustomerValue =
    customerOptions.find(
      (item) => item.value === paymentBalanceData?.customerCode
    ) ||
    (paymentBalanceData?.customerCode
      ? {
        label: paymentBalanceData?.customerName
          ? `${paymentBalanceData.customerName} (${paymentBalanceData.customerCode})`
          : paymentBalanceData.customerCode,
        value: paymentBalanceData.customerCode,
      }
      : null);

  const selectedCategoryValue =
    typeof paymentBalanceData?.category === "string" && paymentBalanceData.category
      ? categoryOptions.find(
        (opt) =>
          opt.label?.trim()?.toLowerCase() ===
          paymentBalanceData.category?.trim()?.toLowerCase()
      ) || {
        label: paymentBalanceData.category,
        value: paymentBalanceData.category,
      }
      : paymentBalanceData?.category || null;

  const repCodeOptions =
    employeeCodeOptions
      ?.filter(
        (item) => item?.employeeCode && String(item.employeeCode).trim() !== ""
      )
      ?.map((item) => {
        const code = String(item.employeeCode).trim();
        const name = item?.employeeName ? String(item.employeeName).trim() : "";
        return {
          label: name ? `${code} (${name})` : code,
          value: code,
          code: code,
          repName: name,
          employeeName: name,
        };
      }) || [];

  const rawRepCode =
    paymentBalanceData?.repCode?.code ||
    paymentBalanceData?.repCode?.value ||
    (typeof paymentBalanceData?.repCode === "string"
      ? paymentBalanceData.repCode.trim()
      : "");

  const selectedRepCodeValue =
    rawRepCode
      ? repCodeOptions.find((item) => item.value === rawRepCode) || {
        label: paymentBalanceData?.repName
          ? `${rawRepCode} (${paymentBalanceData.repName})`
          : String(rawRepCode),
        value: rawRepCode,
        code: rawRepCode,
        repName: paymentBalanceData?.repName,
      }
      : null;

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Payment Balance Details"
                    : formType == "edit"
                      ? "Edit Payment Balance Details"
                      : "View Payment Balance Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />

        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Rep Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="repCode"
                  placeholder="Select Rep Code"
                  value={selectedRepCodeValue}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={repCodeOptions}
                  onChange={(e, s) => handleRepCodeChange(e, s)}
                  isClearable
                  error={
                    paymentBalanceData.repCodeStatus === "error" ? true : false
                  }
                  success={
                    paymentBalanceData.repCodeStatus === "success"
                      ? true
                      : false
                  }
                  isLoading={employeeLoading}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Rep Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="repName"
                  value={paymentBalanceData?.repName}
                  placeholder="Enter Rep Name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "repName" })
                  }
                  error={
                    paymentBalanceData.repNameStatus === "error" ? true : false
                  }
                  success={
                    paymentBalanceData.repNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customer"
                  placeholder="Select Customer"
                  value={selectedCustomerValue}
                  options={customerOptions}
                  rows={3}
                  onChange={(e) => handleCustomerChange(e)}
                  isClearable
                  isDisabled={inputDisble}
                  isLoading={customerOptionLoading}
                  error={paymentBalanceData.customerCodeStatus === "error"}
                  success={paymentBalanceData.customerCodeStatus === "success"}
                />
                {paymentBalanceData.customerCodeStatus === "error" && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    {"Invalid Customer"}
                  </p>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Document Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="invoiceNumber"
                  value={paymentBalanceData?.invoiceNumber}
                  placeholder="Enter Invoice Number"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "invoiceNumber" })
                  }
                  error={
                    paymentBalanceData.invoiceNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    paymentBalanceData.invoiceNumberStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  name="soDate"
                  value={paymentBalanceData?.soDate}
                  placeholder="Enter Invoice Number"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "soDate" })
                  }
                  error={
                    paymentBalanceData.soDateStatus === "error" ? true : false
                  }
                  success={
                    paymentBalanceData.soDateStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Balance <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="balance"
                  value={paymentBalanceData?.balance}
                  placeholder="Enter Balance"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "balance" })
                  }
                  error={
                    paymentBalanceData.balanceStatus === "error" ? true : false
                  }
                  success={
                    paymentBalanceData.balanceStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Age of Invoice <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="ageOfInvoice"
                  value={paymentBalanceData?.ageOfInvoice}
                  placeholder="Enter Age Of Invoice"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "ageOfInvoice" })
                  }
                  error={
                    paymentBalanceData.ageOfInvoiceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    paymentBalanceData.ageOfInvoiceStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    ndays <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="ndays"
                  value={paymentBalanceData?.ndays}
                  placeholder="Enter ndays"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "ndays" })
                  }
                  error={
                    paymentBalanceData.ndaysStatus === "error" ? true : false
                  }
                  success={
                    paymentBalanceData.ndaysStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Credit Limit <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="creditLimit"
                  value={paymentBalanceData?.creditLimit}
                  placeholder="Enter Credit Limit"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "creditLimit" })
                  }
                  error={
                    paymentBalanceData.creditLimitStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    paymentBalanceData.creditLimitStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="category"
                  placeholder="Customer Category"
                  value={selectedCategoryValue}
                  options={categoryOptions}
                  onChange={(e, s) => dispatch({ name: s.name, value: e })}
                  isClearable
                  isDisabled={true}
                  error={paymentBalanceData.categoryStatus === "error"}
                  success={paymentBalanceData.categoryStatus === "success"}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/paymentBalance")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkAllFields()}
                onClick={handleAddPaymentBalance}
              >
                {formType === "add"
                  ? "Submit"
                  : "Update" || formType === "payment"
                    ? "Submit"
                    : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default PaymentBalanceForm;
